

export class UserActivationStatus {

    public UniqueIdentifier: string = "";
    public ExpiresOn: Date | string = "";
    public IsLinkValid: boolean | false;
    public CEID: number;
    public ActivationStatus: boolean ;
    constructor(userActivationStatus: UserActivationStatus) {
        this.UniqueIdentifier = userActivationStatus.UniqueIdentifier || '';
        this.ExpiresOn = userActivationStatus.ExpiresOn || '';
        this.IsLinkValid = userActivationStatus.IsLinkValid || false;
        this.CEID = userActivationStatus.CEID || 0;
        this.ActivationStatus = userActivationStatus.ActivationStatus || false;

    }
}